import(/* webpackMode: "eager" */ "/app/src/app/[locale]/about-us/error.tsx");
